import AuthRepositoryGeneral from "./authRepositoryGeneral";

export const AUTH_REPOSITORY_GENERAL = "auth";

const repositories = {
  [AUTH_REPOSITORY_GENERAL]: AuthRepositoryGeneral
};

export const RepositoryFactoryGeneral = {
  get: name => repositories[name]
};
